import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=63198bfd&scoped=true&"
import script from "./EditBrand.vue?vue&type=script&lang=js&"
export * from "./EditBrand.vue?vue&type=script&lang=js&"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=63198bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63198bfd",
  null
  
)

export default component.exports